<template>
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 1L14 7L8 13" stroke="currentColor"/>
    <path d="M14 7H0" stroke="currentColor"/>
  </svg>
</template>

